/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ExternalRequirement from './ExternalRequirement/index'
import No from './No/index'
import React from 'react'
import RequiredTreatmentFields from './RequiredTreatmentFields/index'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements/Requirements/Requirement/Info"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let requirementValueData = fromData.useDataFormat({ viewPath,
context: 'requirement',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: requirementValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RequiredTreatmentFields'}>
<RequiredTreatmentFields
  viewPath={`${viewPath}/RequiredTreatmentFields`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ExternalRequirement'}>
<ExternalRequirement
  viewPath={`${viewPath}/ExternalRequirement`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}